module.exports = __webpack_public_path__ + "img/boton_herramientas.34201958.svg";